import { NavLink, useNavigate } from 'react-router-dom';
import { Search, Users, TrendingUp, LayoutGrid, LogOut, Settings, Share2, KeyRound } from 'lucide-react';

import VerifyEmailBanner from './VerifyEmailBanner';

const links = [
  { to: '/properties', icon: Search, label: 'Buscar' },
  { to: '/admin/properties', icon: LayoutGrid, label: 'Propiedades' },
  { to: '/agent/clients', icon: Users, label: 'Clientes' },
  { to: '/leads', icon: TrendingUp, label: 'Leads' },
  { to: '/admin/rentals', icon: KeyRound, label: 'Rentas' },
  { to: '/admin/agency', icon: Settings, label: 'Agencia' },
  { to: '/agent/client-views', icon: Share2, label: 'Selecciones' },
];

export function AppNav() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    navigate('/login');
  };

  return (
    <>
    <header className="sticky top-0 z-20 bg-background/95 backdrop-blur-sm border-b border-border">
      <div className="max-w-7xl mx-auto px-6 h-14 flex items-center justify-between">
        <div className="flex items-center gap-7">
          {/* Brand mark */}
          <NavLink to="/properties" className="flex items-center gap-2 group">
            <div className="w-6 h-6 rounded-md bg-primary flex items-center justify-center shadow-sm">
              <span className="text-white text-[10px] font-bold tracking-tight">T</span>
            </div>
            <span className="font-semibold tracking-tight text-sm">Takarah</span>
          </NavLink>

          <div className="hidden md:block w-px h-4 bg-border" />

          <nav className="hidden md:flex items-center gap-0.5">
            {links.map(({ to, icon: Icon, label }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  `relative flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm transition-all duration-150 ${
                    isActive
                      ? 'text-primary font-medium'
                      : 'text-muted-foreground hover:text-foreground hover:bg-muted/50'
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <Icon className="w-3.5 h-3.5" />
                    {label}
                    {isActive && (
                      <span className="absolute inset-x-1.5 -bottom-[1px] h-[2px] rounded-full bg-primary" />
                    )}
                  </>
                )}
              </NavLink>
            ))}
          </nav>
        </div>

        <button
          onClick={handleLogout}
          className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          <LogOut className="w-3.5 h-3.5" />
          <span className="hidden sm:inline text-xs">Salir</span>
        </button>
      </div>

      {/* Mobile bottom nav */}
      <nav className="md:hidden flex overflow-x-auto scrollbar-none border-t border-border bg-background/98">
        {links.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex-1 min-w-[56px] flex flex-col items-center gap-0.5 py-2.5 text-[9px] font-medium transition-colors ${
                isActive ? 'text-primary' : 'text-muted-foreground'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon className={`w-4 h-4 transition-transform ${isActive ? 'scale-110' : ''}`} />
                {label}
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </header>
    {/* auth 007: persistente hasta verificar; no bloquea la navegación */}
    <VerifyEmailBanner />
    </>
  );
}
